import { Component, ElementRef, inject, OnInit, signal, ViewChild } from '@angular/core';
import { takeUntil } from 'rxjs/operators';

import { ShopService } from '@app/shared/services/shop.service';
import { TakeUntilDestroy } from '@shared/decorators/take-until-destroy.decorator';
import { ShopOffersProvider, ShopOffersPurchase } from '@shared/models/shop-offers.model';
import { LoggerService } from '@app/shared/services/logger.service';
import { EventManager } from '@app/shared/utils/event-manager';
import { Modal, ModalType, NonPersistedModalName } from '@app/shared/models/modal.model';
import { NativeService } from '@shared/services/native.service';
import { Observable } from 'rxjs';
import { AdyenService } from '@app/shared/modals/adyen-modal/adyen.service';

@TakeUntilDestroy
@Component({
  selector: 'slotcom-payment-provider-settings',
  templateUrl: './shop-payment-provider.component.html',
  styleUrls: ['./shop-payment-provider.component.scss'],
  standalone: true,
})
export class ShopPaymentProviderComponent implements OnInit {
  @ViewChild('paypalForm', { static: false })
  set paypalForm(form: ElementRef | undefined) {
    if (form) {
      form.nativeElement.submit();
      this.emptyPurchase();
    }
  }

  @ViewChild('iapForm', { static: false })
  set iapForm(form: ElementRef | undefined) {
    if (form) {
      this.startIapPurchase();
      this.emptyPurchase();
    }
  }

  purchaseShopOffers = signal<ShopOffersPurchase>(undefined);
  componentDestroy: () => Observable<unknown>;

  private shopService = inject(ShopService);
  public logger = inject(LoggerService);
  private eventManager = inject(EventManager);
  private nativeService = inject(NativeService);
  private adyenService = inject(AdyenService);

  ngOnInit() {
    this.shopService.purchaseShopOffers$.pipe(takeUntil(this.componentDestroy())).subscribe({
      next: (purchaseShopOffers: ShopOffersPurchase) => {
        this.purchaseShopOffers.set(purchaseShopOffers);
        if (purchaseShopOffers.provider == ShopOffersProvider.adyen) {
          this.adyenService.createCheckoutInstance(purchaseShopOffers.response.providerSettings.session);

          this.eventManager.openModal(
            new Modal(NonPersistedModalName.AdyenModalComponent, ModalType.View, purchaseShopOffers)
          );
        }
      },
      error: (error) => this.logger.error(error),
    });
  }

  private startIapPurchase() {
    const purchase = this.purchaseShopOffers();
    this.nativeService
      .startIapPurchase(purchase.response.iapCode, purchase.response.token)
      .catch((e) => this.logger.error(e));
  }

  private emptyPurchase() {
    this.purchaseShopOffers.set(undefined);
  }
}
